import * as React from 'react'

import { CalendarSyncIcon, FileTextIcon, MoveRightIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { IWorkflowStep, WorkflowStepType } from '~/client/graph'
import { getWorkflowStepLevel } from '~/client/src/shared/constants/formStatusesTags'
import { getWorkflowStepDisplayName } from '~/client/src/shared/localization/enumDisplayTexts'

interface IProps {
  workflowSteps: IWorkflowStep[]

  selectedStepId?: string
  onStepClick?(stepId: string): void
}

@observer
export default class FormWorkflowSteps extends React.Component<IProps> {
  public render() {
    const { selectedStepId, workflowSteps, onStepClick } = this.props

    return (
      <div className="px50 mt10 mb10 row">
        {workflowSteps.map(({ id, type, fields }, index) => (
          <div key={id} className="row no-grow">
            {!!index && <MoveRightIcon className="tw:text-muted-foreground" />}
            <div className="col x-center no-grow text large nowrap">
              <div
                className={classList({
                  'bg-cool-grey brada4 px10 py5 pointer ba2-transparent row y-center tw:gap-1.5': true,
                  'ba2-slate-light-hover': selectedStepId !== id,
                  'ba2-group-highlight': selectedStepId === id,
                })}
                onClick={onStepClick?.bind(null, id)}
              >
                {`${index + 1}. ${getWorkflowStepDisplayName(
                  type,
                  getWorkflowStepLevel(id, workflowSteps),
                )}`}
                {!!fields.length && (
                  <FileTextIcon
                    size={16}
                    className="tw:text-muted-foreground"
                  />
                )}
                {type === WorkflowStepType.RecurringInspection && (
                  <CalendarSyncIcon size={16} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}
